import React, { useContext, useMemo, useState } from 'react';
import styled from 'styled-components';

import Icon from 'kingpin/atoms/Icon';
import Typography from 'kingpin/atoms/Typography';
import ContentUsage from 'components/ContentUsage';
import Row from 'components/Common/Row';
import EntityDefinitionsContext from 'contexts/EntityDefinitionsContext';
import ReportContext from 'contexts/ReportContext';

const CompactAlert = styled.div`
  background-color: var(--color-badge-info-bg);
  border: 1px solid var(--color-badge-info-border);
  border-radius: 8px;
  padding: 6px 10px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`;

const EntityAppUsageAlert = () => {
  const { report } = useContext(ReportContext);
  const { entityDetailsApps } = useContext(EntityDefinitionsContext);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const entityApps = useMemo(() => {
    if (!report) {
      return [];
    }
    return entityDetailsApps.filter((app) =>
      app.tabs.some((t) => t.type === 'report' && t.typeId === report.id),
    );
  }, [report, entityDetailsApps]);

  if (entityApps.length === 0) {
    return null;
  }

  const count = entityApps.length;
  const label = `This report is used on ${count} entity app${count !== 1 ? 's' : ''}.`;

  return (
    <>
      <CompactAlert onClick={() => setIsOpen(true)}>
        <Row centerAlign style={{ gap: 4 }}>
          <Typography.Body type="Body 12">{label}</Typography.Body>
          <Icon icon="open-link" width={12} height={12} />
        </Row>
      </CompactAlert>
      <ContentUsage
        isOpen={isOpen}
        close={() => setIsOpen(false)}
        type="report"
      />
    </>
  );
};

export default EntityAppUsageAlert;
